import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NavController, App, LoadingController } from 'ionic-angular';
import { EventDetailsModel, EventProvider, EventTievts } from '../../providers/event/event';
import { TranslateService } from '@ngx-translate/core';
import { EventTabsPage } from '../../pages/event/details/event-tabs/event-tabs';
import { EventListPage } from '../../pages/event/event-list/event-list';


@Component({
    selector: 'container-with-items',
    templateUrl: 'container-with-items.html'
})
export class ContainersWithItemsComponent {
    
    @Input("index") containerIndex = null;
    @Input() container: ContainerWithItems; 
    @Output() expandContainer = new EventEmitter<ContainerWithItems>();

    constructor(
        public navCtrl: NavController,
        private translate: TranslateService,
        private app: App,
        private loadingCtrl: LoadingController,
        private eventService: EventProvider
    ) { }

    onExpandContainer(){
        this.expandContainer.emit(this.container);
    }

    getEventStatus(event: EventTievts) {
        if (typeof event === "undefined") return "";
        let status = event.eventStatus;
        if (status.toUpperCase().includes("CANCELLED")) return this.translate.instant('EVENT_CANCELLED');
        else if (status.toUpperCase().includes("NOT_CONFIRMED")) return this.translate.instant('NOT_CONFIRMED');
        else return "";
    }


    openEventDetails(event) {
        let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
        loader.present();
        this.eventService.getEventId(event.eventName, event.ort, event.dateFormatted, event.cid).then(id => {
            if (id == -1) { loader.dismiss(); return; };

            this.eventService.getEventDetails(id).then((event: EventDetailsModel) => {
                if (event.name.length < 1) {
                    this.openEventDetails(event);
                    loader.dismiss();
                } else {
                    (this.app.getRootNav() as NavController).push(EventTabsPage, { event: event }).then(() => loader.dismiss());
                }
            });
        })
    }
}

export interface ContainerWithItems { 
    eventArea: string;
    eventType: string;
    items: any [];
    index?: number;
}


// WEBPACK FOOTER //
// /src/components/container-with-items/container-with-items.ts